import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Radio,
  Table,
  Space,
  Popconfirm,
  Modal
} from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";


//mobx
import { useStore } from "@/store";
import { observer } from "mobx-react-lite";
import { toJS, runInAction, set } from "mobx";
//mobx'

import AuthorityInput from './AuthorityInput'

const Authority = () => {
  //mobx
  const { AuthorityStore } = useStore();
  const [uid, setUid] = useState('')
  //获得table数据
  useEffect(() => {
    AuthorityStore.getDataList();
    AuthorityStore.getSelectList()
    AuthorityStore.getSelectList2()
    setUid(JSON.parse(window.localStorage.getItem('uid')) || '')
    // eslint-disable-next-line
  }, []);

  //分页控制
  const onPageChange = (page, pageSize) => {
    runInAction(() => {
      set(AuthorityStore, { page: page, pagesize: pageSize })
    })
    AuthorityStore.getDataList()
  }
  //分页控制

  //关闭X按钮
  const handleRevise = () => {
    runInAction(() => {
      set(AuthorityStore, { isActive: false });
    });
  };

  //单个删除按钮
  const deleteConfirm = async (item) => {
    let id = toJS(item).id;
    toJS(AuthorityStore.dataList).filter((item) => item.id !== id);
    await AuthorityStore.getDeleteButtom(id);
  };

  //新增账户
  const getAddButton = (addTitle, data) => {
    if (addTitle === '编辑') {
      runInAction(() => {
        set(AuthorityStore, { valueData: toJS(data) });
      })
    }
    runInAction(() => {
      set(AuthorityStore, { title: addTitle, isActive: true });
    });
  };

  // 取消按钮
  const [form] = Form.useForm();

  const [size, setSize] = useState('one')
  const handleButton = async (e) => {
    setSize(e.target.value)
    let status = ''
    if (e.target.value === "one") {
      status = ''
    } else if (e.target.value === "two") {
      status = 'hidden'
    } else if (e.target.value === 'three') {
      status = 'normal'
    }
    await AuthorityStore.getDataList(status, e.target.value)
  }

  //table 列表
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
    },
    {
      title: '用户名',
      dataIndex: 'username',
    },
    {
      title: '密码',
      dataIndex: 'passworda',
    },
    {
      title: '用户角色',
      dataIndex: 'groups_text',
    },
    {
      title: '昵称',
      dataIndex: 'nickname',
    },
    {
      title: '手机号',
      dataIndex: 'mobile',
    },
    {
      title: '所在地区',
      dataIndex: 'area_name',
    },
    {
      title: '状态',
      dataIndex: 'status',
      render: (text) => text === 'normal' ? "启用" : "禁用"
    },
    {
      title: "操作",
      render: (item) => (
        uid === 1 ? <>

          <Space size="middle">
            <Button
              type="primary"
              icon={<EditOutlined />}
              onClick={() => {
                item.username = item.username + ' '
                getAddButton("编辑", item)
              }}
            >编辑</Button>
            <Popconfirm
              title="是否删除?"
              okText="确定"
              cancelText="取消"
              onConfirm={() => {
                deleteConfirm(item);
              }}
            >
              {<Button type="primary" icon={<DeleteOutlined />} danger>删除</Button>}
            </Popconfirm>

          </Space>
        </> : <>
          {item.id === 1 ? null :
            <Space size="middle">
              <Button
                type="primary"
                icon={<EditOutlined />}
                onClick={() => {
                  item.username = item.username + ' '
                  getAddButton("编辑", item)
                }}
              >编辑</Button>
              <Popconfirm
                title="是否删除?"
                okText="确定"
                cancelText="取消"
                onConfirm={() => {
                  deleteConfirm(item);
                }}
              >
                {<Button type="primary" icon={<DeleteOutlined />} danger>删除</Button>}
              </Popconfirm>

            </Space>}
        </>

      ),
    },
  ];

  return (
    <>
      <div className="TableInput">
        <div className="buttonBox">
          <Radio.Group value={size} onChange={(e) => { handleButton(e) }} type="primary" style={{ marginRight: '10px' }}>
            <Radio.Button value="one">全部</Radio.Button>
            <Radio.Button value="two">禁用</Radio.Button>
            <Radio.Button value="three">启用</Radio.Button>
          </Radio.Group>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            className="addTitle"
            onClick={() => {
              getAddButton("添加", '')
            }}
          >
            添加用户
          </Button>
        </div>
        <div className="total">共有数据:{AuthorityStore.total}条</div>
      </div>

      <div className="contextNr">
        <Table
          rowKey={(record) => record.id}
          columns={columns}
          dataSource={AuthorityStore.dataList}
          className="table-box"
          pagination={{
            position: ["bottomCenter"],
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ['10', '20', '30'],
            pageSize: AuthorityStore.pagesize,
            current: AuthorityStore.page,
            total: AuthorityStore.total,
            onChange: (page, pageSize) => onPageChange(page, pageSize),
          }}
        />
      </div>
      <Modal
        title={AuthorityStore.title}
        key={new Date()}
        width="600px"
        open={AuthorityStore.isActive}
        footer={null}
        onCancel={handleRevise}
      >
        <AuthorityInput title={AuthorityStore.title} />
      </Modal>
    </>
  );
};

export default observer(Authority);
